import { TimelineItem } from '@/common/components/timeline/subcomponents/timeline-item/TimelineItem.tsx';
import { TimelineIcon } from '@/common/components/timeline/subcomponents/timeline-icon/TimelineIcon.tsx';
import { blueGrey } from '@mui/material/colors';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ReactNode, useId } from 'react';
import Typography from '@mui/material/Typography';

export interface TimelineLoadingProps {
  label: ReactNode;
}

export const TimelineLoading = ({ label }: TimelineLoadingProps) => {
  const id = useId();

  const loadingLabelId = `loading-label-${id}`;
  return (
    <TimelineItem
      isLast
      icon={
        <TimelineIcon color={blueGrey}>
          <CircularProgress size={16} color="inherit" aria-labelledby={loadingLabelId} />
        </TimelineIcon>
      }
      rightContent={
        <Box pt={2}>
          <Typography color="textSecondary" id={loadingLabelId}>
            {label}
          </Typography>
        </Box>
      }
    />
  );
};
